const isRdp = remoteAppMetadata =>
  remoteAppMetadata && remoteAppMetadata.name?.toLowerCase() === 'adrdp';

export default isRdp;